"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountPasswordLoginRequest = void 0;
var AccountPasswordLoginRequest = /** @class */ (function () {
    function AccountPasswordLoginRequest() {
    }
    return AccountPasswordLoginRequest;
}());
exports.AccountPasswordLoginRequest = AccountPasswordLoginRequest;
;
//# sourceMappingURL=accountPasswordLogin.request.js.map